export const brandImageFromService = (image) => ({
    url: image.url,
    ...("alt" in image && { alt: image.alt }),
    ...("is_logo" in image && { isLogo: image.is_logo }),
    ...("is_hero" in image && { isHero: image.is_hero }),
    ...("is_product" in image && { isProduct: image.is_product }),
    ...("width" in image && { width: image.width }),
    ...("height" in image && { height: image.height })
});
export const brandColorsFromService = (colors) => ({
    primaryColors: colors.primary_colors,
    secondaryColors: colors.secondary_colors,
    accentColors: colors.accent_colors,
    backgroundColors: colors.background_colors,
    textColors: colors.text_colors
});
export const brandInsightFromService = (insight) => ({
    category: insight.category,
    title: insight.title,
    description: insight.description,
    ...("confidence" in insight && { confidence: insight.confidence }),
    ...("icon_key" in insight && { iconKey: insight.icon_key }),
    ...("source_evidence" in insight && { sourceEvidence: insight.source_evidence })
});
//# sourceMappingURL=brand.js.map